<template>
  <div class="error-page">
    <h1>Error {{ error.statusCode }}: {{ error.statusMessage }}</h1>

    <!-- the “real” error text you threw -->
    <p v-if="error.message"><strong>Details:</strong> {{ error.message }}</p>

    <!-- and in dev you’ll often get a stack trace -->
    <pre v-if="error.stack" class="mt-4 p-2 bg-gray-100 rounded overflow-auto">
      {{ error.stack }}
    </pre>

    <!-- for a full dump you can even JSON-stringify it -->
    <pre class="mt-4">{{ JSON.stringify(error, null, 2) }}</pre>

    <button class="btn my-7" @click="clearError({ redirect: '/' })">
      Go Home…
    </button>
  </div>
</template>

<script setup lang="ts">
import { clearError, type NuxtError } from '#app';

defineProps<{
  error: NuxtError;
}>();
</script>

<style scoped>
.error-page { max-width: 600px; margin: 2rem auto; }
</style>
